import { render, staticRenderFns } from "./delTask.vue?vue&type=template&id=51172801&scoped=true&"
import script from "./delTask.vue?vue&type=script&lang=js&"
export * from "./delTask.vue?vue&type=script&lang=js&"
import style0 from "./delTask.vue?vue&type=style&index=0&id=51172801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51172801",
  null
  
)

component.options.__file = "delTask.vue"
export default component.exports